export const name = '$gzColumns';

export default function $gzColumns(
) {
  //noinspection BadExpressionStatementJS
  'ngInject';


  var unitTest = {
  };

  var service = {
    unitTest: unitTest
  };

  activate();
  return service;

  function activate() {
  }

  //
  // Public functions
  //

  //
  // Private functions
  //
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/extensions/grid/columns/columns.service.js